import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Dropdown } from 'floating-vue'
import 'floating-vue/dist/style.css'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTooltip',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dropdown), { triggers: ['hover', 'click', 'focus'] }, {
    popper: _withCtx(() => [
      _renderSlot(_ctx.$slots, "popover")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "trigger")
    ], undefined, true),
    _: 3
  }))
}
}

})